import React, { Component } from "react";
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton } from "@ionic/react";

// css
import "../Shared.css";
import "../../App.css";
import "./PathwayCell.css";

// controllers
import {
  IScreenProps,
  IUser,
  IGuideline,
  IGuidelineSummary,
  IAlgorithm,
  IAnnotation,
  IClinicalNotice,
  IPathway,
} from "../Interfaces";

// images
import indicatorBookmark from "../assets/Button_Bookmark_3Small@3x.png";
import indicatorUpdate from "../assets/Indicator_Update@3x.png";

type Props = {
  pathway: IPathway;
  bookmarked: boolean;
  searchText?: string;
  cellClicked?: (pathway: IPathway) => void;
};
type State = {};

class PathwayCell extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  cellClicked() {
    if (this.props.cellClicked) {
      this.props.cellClicked(this.props.pathway);
    }
  }

  render() {
    let pathway = this.props.pathway;
    let titleText = "";
    if (pathway.fields["Pathway name"]) {
      titleText = pathway.fields["Pathway name"];
    }
    let areaText = "";
    if (pathway.areas && pathway.areas.length > 0) {
      areaText = pathway.areas.join(", ");
    }

    let categoriesText = "";
    if (pathway.categories && pathway.categories.length > 0) {
      categoriesText = pathway.categories.join(", ");
    }

    let maxLineNumber = 2;

    // add highlighting to title text if there is a search term
    let titleTextHtml = titleText;
    if (titleText.length > 0 && this.props.searchText) {
      let beginningOfSearchTerm = titleText.toLowerCase().indexOf(this.props.searchText.toLowerCase());
      let endOfSearchTerm = beginningOfSearchTerm + this.props.searchText.length;

      if (beginningOfSearchTerm !== -1) {
        titleTextHtml =
          titleText.substr(0, beginningOfSearchTerm) +
          '<span class="searchResultCellHighlight">' +
          titleText.substr(beginningOfSearchTerm, this.props.searchText.length) +
          "</span>" +
          titleText.substr(endOfSearchTerm, titleText.length);
      }
    }

    return (
      <div className={`guidelineCell`} tabIndex={0} role="button" onClick={this.cellClicked.bind(this)}>
        <div className={`sliver pathway`} />
        <div className="guidelineCellContents">
          <div className="guidelineCellTopContents">
            <div className="pathwayCardCellTextContent">
              <div
                className="pathwayCardCellTitle"
                style={{ WebkitLineClamp: maxLineNumber }}
                dangerouslySetInnerHTML={{
                  __html: titleTextHtml,
                }}
              />
              <div className="pathwayCardCellAreas" style={{ WebkitLineClamp: maxLineNumber }}>
                {areaText}
              </div>
              <div className="pathwayCardCellCategories" style={{ WebkitLineClamp: maxLineNumber }}>
                {categoriesText}
              </div>
            </div>
            <div className="guidelineIcons">
              {this.props.bookmarked ? <img className="bookmarkIcon" src={indicatorBookmark} alt="" /> : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PathwayCell;
